import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import ContactEdit          from "./ContactEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Contact List
 * @returns {React.ReactElement}
 */
function ContactList() {
    const { fetch, load } = useList("contact");

    const data = Store.useState("contact");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("contact");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "contactID", elemID, "name");

    return <Main>
        <Header message="CONTACTS_NAME" icon="contact">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="CONTACTS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"          message="GENERAL_NAME"        isTitle />
                    <TableHeader field="categoryName"  message="CATEGORIES_SINGULAR" />
                    <TableHeader field="activityName"  message="ACTIVITIES_SINGULAR" />
                    <TableHeader field="whatsApp"      message="GENERAL_WHATSAPP"    />
                    <TableHeader field="phone"         message="GENERAL_PHONE"       />
                    <TableHeader field="email"         message="GENERAL_EMAIL"       />
                    <TableHeader field="status"        message="GENERAL_STATUS"      align="center" maxWidth="100" />
                    <TableHeader field="finalPosition" message="GENERAL_POSITION"    maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.contactID} elemID={elem.contactID}>
                        <TableCell message={elem.name}          />
                        <TableCell message={elem.categoryName}  />
                        <TableCell message={elem.activityName}  />
                        <TableCell message={elem.whatsApp}      />
                        <TableCell message={elem.phone}         />
                        <TableCell message={elem.email}         />
                        <TableCell message={elem.statusName}    textColor={elem.statusColor} />
                        <TableCell message={elem.finalPosition} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="CONTACTS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="CONTACTS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ContactEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="CONTACTS_DELETE_TITLE"
            message="CONTACTS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default ContactList;
